"use client"

import styled from "@emotion/styled"
import { Divider, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import React from "react"
import { getNonUmbracoUrl, Link } from "utils"
import { Desktop, Mobile } from "../../common/bit/MediaQueries"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

const StyledLinksRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 16px;
  column-gap: 12px;
  flex-wrap: wrap;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: unset;
    gap: 16px;
  }
`
const StyledLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
  &:hover {
    box-shadow: inset 0 -1px 0 0 white;
  }
`

const StyledDivider = styled(Divider)`
  height: 11px;
  width: 1px;
  background-color: white;
`

const OtherDetails = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
  }
`

const DetailRow = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: unset;
  }
`

export default function LowerLinks({
  bottomLinksItems,
  text,
}: {
  bottomLinksItems: {
    name: string
    url: string
  }[]
  text: string
}) {
  const t = useTranslations("Homepage")
  const currentYear = new Date().getFullYear()

  // Get the copyright text with dynamic year replacement
  const copyrightText = t("copyrightEggedT", { year: currentYear })
  const createdByText = t("createdByMint").trim()
  return (
    <StyledLayout>
      <StyledLinksRow>
        {bottomLinksItems.map((el, i) => {
          return (
            <React.Fragment key={i}>
              <StyledLink
                href={
                  el?.url && el?.url !== "#" ? getNonUmbracoUrl(el.url) : "/"
                }
                prefetch={false}
              >
                <Desktop>
                  <Typography variant="body3" color="white">
                    {el.name}
                  </Typography>
                </Desktop>
                <Mobile>
                  <Typography variant="body2" color="white">
                    {el.name}
                  </Typography>
                </Mobile>
              </StyledLink>
              {i !== bottomLinksItems.length - 1 && <StyledDivider />}
            </React.Fragment>
          )
        })}
      </StyledLinksRow>
      <OtherDetails>
        <DetailRow>
          <Desktop>
            <Typography variant="body3" color="white">
              {copyrightText}
            </Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body2" color="white">
              {copyrightText}
            </Typography>
          </Mobile>
        </DetailRow>
        <DetailRow>
          <Image alt="" src="/icons/mintLogo.svg" width={72} height={17} />
          <Desktop>
            <Typography variant="body3" color="white">
              {createdByText}
            </Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body2" color="white">
              {createdByText}
            </Typography>
          </Mobile>
        </DetailRow>
      </OtherDetails>
    </StyledLayout>
  )
}
